import React, { useState } from "react";
import Header from "@components/RecruiterHeader/RecruiterHeader";
import SideBar from "@components/RecruiterSideBar/RecruiterSideBar";
import { Outlet } from "react-router-dom";
import './Recruiter.scss';

const Recruiter: React.FC = () => {
  const [sidebarCollapse, setSidebarCollapse] = useState(false);

  return (
    <div className="Recruiter">
      <SideBar
        sidebarCollapse={sidebarCollapse}
        setSidebarCollapse={setSidebarCollapse}
      />
      <main
        className="main-recruiter bg-transparent py-3 px-5"
        style={{
          marginLeft: !sidebarCollapse ? "272px" : "90px",
          transition: "all 0.4s ease",
        }}
      >
        <Header />
        <div className="container-fluid p-0 " style={{ marginTop: "20px", flex: 1 }}>
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default Recruiter;
